export default "__VITE_ASSET__CfeDAISZ__"